import {Nullish} from 'shared/web';

import {AlphaCatalogue} from '../types/AlphaCatalogue';

type AlphaCatalogueLabelParams = {
  propertyName: string;
  alphaCatalogue: AlphaCatalogue;
  vehicleType: string | Nullish;
  key: string | Nullish;
};

export const getAlphaCatalogueLabel = (params: AlphaCatalogueLabelParams): string | Nullish =>
  params.alphaCatalogue
    ?.find(
      (property) =>
        property.vehicle_type === params.vehicleType &&
        property.property_name === params.propertyName
    )
    ?.keys?.find((propertyKey) => propertyKey.const_key === params.key)?.labels?.[0]?.label ??
  params.key;
